import { useState, useCallback } from 'react';
import { SnackbarState } from '../types';

export const useNotifications = () => {
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    message: '',
    severity: 'success'
  });

  const showNotification = useCallback((
    message: string, 
    severity: 'success' | 'error' | 'info' | 'warning'
  ) => {
    setSnackbar({
      open: true,
      message,
      severity
    });
  }, []);

  const handleCloseSnackbar = useCallback(() => {
    setSnackbar(prev => ({ ...prev, open: false }));
  }, []);

  return {
    snackbar,
    showNotification,
    handleCloseSnackbar
  };
};

